import React, { useState } from 'react';
import { C, STAGES } from '@/lib/constants';
import type { Program } from '@/lib/types';
import { Badge } from './Badge';
import { ProgressBar } from './ProgressBar';
import { MemberAvatar } from './MemberAvatar';
import type { TeamMember } from '@/lib/types';

interface PipelineCardProps {
  program: Program;
  onClick: () => void;
  teamMembers?: TeamMember[];
}

export const PipelineCard = React.memo(function PipelineCard({ program, onClick, teamMembers = [] }: PipelineCardProps) {
  const [hovered, setHovered] = useState(false);
  const stageColor = STAGES.find(s => s.key === (program.stage as string))?.color || C.mid;
  const prioColor: Record<string, string> = { high: "var(--error)", medium: C.peach, low: C.charcoal };

  return (
    <div onClick={onClick} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
      className="bg-card rounded p-4 pointer pipeline-card transition-200" style={{ border: `1px solid ${hovered ? stageColor : "var(--border)"}`, boxShadow: hovered ? "0 4px 16px rgba(0,0,0,0.06)" : "0 1px 3px rgba(0,0,0,0.03)", transform: hovered ? "translateY(-2px)" : "none" }}>
      <div className="flex justify-between items-start mb-3">
        <span className="h4 lh-snug flex-1 pipeline-card-title">{program.name}</span>
        <Badge color={prioColor[program.priority || 'medium']}>{program.priority}</Badge>
      </div>
      <div className="flex items-center gap-2 text-md text-mid mb-4">
        <span className="fw-600 text-dark">{program.productCount}</span> products
        <span className="text-border">·</span>{program.channel}
      </div>
      <div className="mb-5">
        <ProgressBar percent={Math.round((STAGES.findIndex(s => s.key === program.stage) / (STAGES.length - 1)) * 100)} color={stageColor} />
      </div>
      <div className="flex-between">
        <div className="text-sm text-light">Due {program.deadline}</div>
        <MemberAvatar
          member={teamMembers.find(t => t.name === program.assignee || t.email === program.assignee)}
          name={program.assignee}
        />
      </div>
    </div>
  );
});
